import React from 'react'
import PropTypes from 'prop-types'
import {Field, reduxForm, SubmissionError} from 'redux-form'
import {Link} from 'react-router'
import FormInput from 'components/FormInput'
import Button from 'components/Button'
import Icon from 'components/Icon'
import {setPassword} from 'redux/modules/currentUser/actions'

class SetPasswordForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool
  }

  render() {
    const {handleSubmit, invalid, submitting} = this.props

    return (
      <div className='auth-view_content is-single'>
        <div className='auth-view_panel'>
          <div className='auth-view_panel_body'>
            <form className='auth-view_form' onSubmit={handleSubmit}>
              <div className='auth-view_title'>Password reset</div>
              <Field
                className='auth-view_form-field'
                name='password'
                placeholder='New password'
                type='password'
                disabled={submitting}
                component={FormInput}
              />
              <Field
                className='auth-view_form-field'
                name='passwordRepeat'
                placeholder='Repeat password'
                type='password'
                disabled={submitting}
                component={FormInput}
              />
              <Button disabled={invalid || submitting} color='green' type='submit'>
                Set password
                <Icon className='auth-view_form_button_icon' name='arrow-button' size='23px' />
              </Button>
            </form>
            <p className='auth-view_panel_text is-left'>
              Back to {' '}<Link className='auth-view_panel_text_link' to='/login'>Login</Link>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default reduxForm({
  form: 'reset',
  validate: ({password, passwordRepeat}) => {
    const errors = {}

    if (!password) {
      errors.password = 'Password is required'
    } else if (password !== passwordRepeat) {
      errors.passwordRepeat = 'Passwords do not match'
    }

    return errors
  },
  onSubmit: ({password}, dispatch, props) => new Promise((resolve, reject) => {
    const {uid, token} = props.location.query
    dispatch(setPassword({uid, token, password}))
      .success(resolve)
      .fail(err => {
        reject(new SubmissionError({_error: err.message}))
      })
  })
})(SetPasswordForm)



// WEBPACK FOOTER //
// ./client/views/AuthView/SetPasswordForm.js